export default __webpack_public_path__ + "static/sdk-giphy-text-a79d669a91d580700f8be8f3a7d27fc1.gif";